import { GraphqlQueryResponse } from '~/types/apollo-graphql-types'
import {
  HistoricalValues,
  IHandledResponse,
  IReportInfo,
  ReportMeta,
  ReportPageT
} from '~/types/reportTypes'
import { getFormattedCodeHealthChartData } from '~/utils/reports'

const reportKey = ReportPageT.CODE_HEALTH_TREND

export default {
  key: reportKey,
  query: 'pinnedReportData',
  componentName: 'PinnedChartReport',
  handleResponse: (response: GraphqlQueryResponse) => {
    const { report } = response.data

    const handledResponse: IHandledResponse = {
      label: ReportMeta[reportKey].title,
      value: report?.currentValue ?? 0,
      valueLabel:
        report?.currentValue === 1 ? 'net new issue this month' : 'net new issues this month'
    }

    const { historicalValues } = report as { historicalValues: HistoricalValues }
    handledResponse.datasets = getFormattedCodeHealthChartData(historicalValues)

    handledResponse.historicalValues = historicalValues

    return handledResponse
  }
} as IReportInfo
